const faImageSlash = {
  prefix: 'fal',
  iconName: 'image-slash',
  icon: [
    576,
    512,
    [],
    'e1b7',
    'M27.3-27.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l544 544c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-68.2-68.2c5.7-9.5 8.9-20.7 8.9-32.6l0-320c0-35.3-28.7-64-64-64L128 32c-11.9 0-23 3.2-32.6 8.9L27.3-27.2zm92.3 92.3c2.7-.7 5.5-1.1 8.4-1.1l320 0c17.7 0 32 14.3 32 32l0 320c0 2.9-.4 5.7-1.1 8.4l-39.5-39.5c1.4-1.8 2.7-3.7 3.8-5.7 7-12.9 6.4-28.5-1.6-40.8l-88-136c-7.4-11.4-20-18.3-33.6-18.3s-26.2 6.9-33.6 18.3l-11.6 18-155.1-155.1zM415.9 361.4l-118-118 15.4-23.7c1.5-2.3 4-3.7 6.7-3.7s5.2 1.4 6.7 3.7l88 136c1.1 1.7 1.5 3.8 1.2 5.7zM64 416c0 35.3 28.7 64 64 64l293.5 0-32-32-261.5 0c-17.7 0-32-14.3-32-32l0-261.5-32-32 0 293.5zM191.2 257.1l-56 80c-8.6 12.2-9.6 28.2-2.7 41.4S153.1 400 168 400l173.5 0-32-32-141.5 0c-3 0-5.7-1.7-7.1-4.3s-1.2-5.8 .5-8.3l55.8-79.7-22.7-22.7c-1.2 1.3-2.3 2.6-3.3 4.1z',
  ],
};
export default faImageSlash;
